import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const paymentApi = createApi({
    reducerPath: 'paymentApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Payments'],
    endpoints: (build) => ({
        getPayments: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return `/payments/all${qs ? `?${qs}` : ''}`;
            },
            providesTags: ['Payments'],
        }),
        getPaymentById: build.query({
            query: (payment_id) => `/payments/details/${payment_id}`,
            providesTags: (result, error, id) => [{ type: 'Payments', id }],
        }),
        getPaymentStats: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return `/payments/stats${qs ? `?${qs}` : ''}`;
            },
            providesTags: ['Payments'],
        }),
    }),
});

export const { useGetPaymentsQuery, useLazyGetPaymentsQuery, useGetPaymentByIdQuery, useGetPaymentStatsQuery } = paymentApi;
